export interface VideoFrameResult {
	imageSrc: string;
	frameNumber: number;
}

export const getVideoFrame = (videoSrc: string, frameNumber: number = 0): Promise<VideoFrameResult> => {
	return new Promise((resolve, reject) => {
		const video = document.createElement("video");

		video.crossOrigin = "anonymous";
		video.muted = true;
		video.preload = "metadata";
		video.src = videoSrc;

		video.addEventListener("loadedmetadata", () => {
			video.currentTime = frameNumber;
		});

		// Ensure video starts loading
		video.load();

		video.addEventListener("seeked", () => {
			const canvas = document.createElement("canvas");
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;

			const ctx = canvas.getContext("2d");
			if (!ctx) {
				reject(new Error("Failed to get canvas context"));
				return;
			}

			ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
			const imageSrc = canvas.toDataURL("image/png");

			resolve({ imageSrc, frameNumber });
		});

		video.addEventListener("error", () => {
			reject(new Error("Failed to load video"));
		});
	});
};
